import type {
  CreateSettlementRequest,
  GroupBalancesResponse,
  SettlementResponse,
} from "@qota/shared";
import { request } from "./http";

export function getBalances(groupId: string): Promise<GroupBalancesResponse> {
  return request<GroupBalancesResponse>("GET", `/groups/${groupId}/balances`);
}

export function listSettlements(groupId: string): Promise<SettlementResponse[]> {
  return request<SettlementResponse[]>("GET", `/groups/${groupId}/settlements`);
}

export function createSettlement(
  groupId: string,
  input: CreateSettlementRequest,
): Promise<SettlementResponse> {
  return request<SettlementResponse>("POST", `/groups/${groupId}/settlements`, input);
}
